const ModalButton = ({modalId, element, className, onClick}) =>{
    return (
        <span style={{cursor:"pointer"}} onClick={onClick} data-bs-toggle="modal" data-bs-target={`#${modalId}`} className={className}>
            {element}
        </span>
    )
}

ModalButton.defaultProps ={
    onClick: (e)=>{e.preventDefault()}
}

export default ModalButton